import PageLayout from './PageLayout';
import { Gallery } from '@/components/wedding';

const GalleryPage = () => (
  <PageLayout testId="gallery-page">
    <Gallery />
  </PageLayout>
);

export default GalleryPage;
